<div class="flex flex-col pt-4 space-y-4">
  <app-section-header
    [title]="pageHeader"
    [isBackBtnShown]="true"
    [backRoute]="['/dashboard']"
    [preserveQueryParam]="true"
  >
    <app-content-state-controls
      *ngIf="initialSingleSponsorContent"
      [allowableNextStates]="
        initialSingleSponsorContent.dynamicData.allowableNextStates
      "
      [isProcessingStateChange]="isProcessingStateChange"
      [isPublished]="initialSingleSponsorContent.isPublished()"
      [isSpiked]="initialSingleSponsorContent.isSpiked"
      [form]="form"
      [isSaving]="isSaving"
      (handleStateChange)="onUpdateState($event)"
      (handleReEditClick)="createNewVersion()"
      (handleCreateClick)="createNewSingleSponsor()"
      (handleReactivateClick)="onReactivateSingleSponsor()"
    ></app-content-state-controls>
  </app-section-header>
  <ng-container *ngIf="isProcessing || initialSingleSponsorContent">
    <app-processing-boundary
      [isProcessing]="isProcessing || !initialSingleSponsorContent"
      [processingMsg]="'Loading...'"
    >
      <div *ngIf="initialSingleSponsorContent">
        <app-content-status-card
          [form]="form"
          [formReady]="formReady.asObservable()"
          [content]="initialSingleSponsorContent"
          [isSaving]="isSaving"
          (handleSave)="onSave()"
          class="px-4"
        ></app-content-status-card>
        <app-content-status-message
          [content]="initialSingleSponsorContent"
          [contentType]="CONTENT_TYPES.SINGLE_SPONSOR"
        ></app-content-status-message>
      </div>
      <form
        class="flex p-4 space-x-4"
        [formGroup]="form"
        *ngIf="initialSingleSponsorContent"
      >
        <mat-tab-group class="flex flex-col flex-1 min-w-0">
          <mat-tab label="Editorial">
            <ng-template matTabContent>
              <div class="space-y-4">
                <app-headline-input
                  [control]="form.get(FORM_PATHS.HEADLINE())"
                ></app-headline-input>
                <app-standfirst-text
                  [control]="form.get(FORM_PATHS.STANDFIRST())"
                ></app-standfirst-text>
                <app-content-editor
                  *ngIf="!isProcessing"
                  [sectionFormControl]="form.get(FORM_PATHS.BODY())"
                  [sectionImgsFormControl]="form.get(FORM_PATHS.IMGS())"
                  [sectionVideosFormControl]="form.get(FORM_PATHS.VIDEOS())"
                  [isDisabled]="!isEditMode"
                ></app-content-editor>
              </div>
            </ng-template>
          </mat-tab>
          <mat-tab label="Advertorial">
            <ng-template matTabContent>
              <div class="space-y-4">
                <app-headline-input
                  [control]="form.get(FORM_PATHS.SPONSORED_HEADLINE())"
                ></app-headline-input>
                <app-standfirst-text
                  [control]="form.get(FORM_PATHS.SPONSORED_STANDFIRST())"
                ></app-standfirst-text>
                <app-media-adder
                  [sectionImgsFormControl]="
                    form.get(FORM_PATHS.SPONSORED_MAIN_IMAGE())
                  "
                  [sectionVideosFormControl]="
                    form.get(FORM_PATHS.SPONSORED_MAIN_VIDEO())
                  "
                  [isMainMedia]="true"
                  [addMediaLabel]="'Add main'"
                  [isDisabled]="!isEditMode"
                ></app-media-adder>
                <app-content-editor
                  *ngIf="!isProcessing"
                  [sectionFormControl]="form.get(FORM_PATHS.SPONSORED_BODY())"
                  [sectionImgsFormControl]="
                    form.get(FORM_PATHS.SPONSORED_IMGS())
                  "
                  [sectionVideosFormControl]="
                    form.get(FORM_PATHS.SPONSORED_VIDEOS())
                  "
                  [isDisabled]="!isEditMode"
                ></app-content-editor>
              </div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
        <div class="flex flex-1 min-w-0 pt-1.5 mt-2">
          <mat-accordion [multi]="false" class="flex flex-1 space-x-3">
            <div class="flex flex-col w-1/2 space-y-3 basis-1/2">
              <app-expandable-checkbox-list
                [iconClass]="'icon-globe'"
                [title]="'Websites'"
                [formGroup]="form.get(FORM_PATHS.WEBSITES())"
                [metadata]="deliveryTargets$ | async"
                [isExpandedByDefault]="isNewSingleSponsor"
                [isExpandable]="isEditMode"
                (onItemChecked)="onEditionAdded($event)"
                (onItemUnchecked)="onEditionRemoved($event)"
              ></app-expandable-checkbox-list>
              <app-sponsored-author-section
                [sponsoredAuthorsControl]="
                  form.get(FORM_PATHS.SPONSORED_AUTHORS())
                "
                [isExpandable]="isEditMode"
                [isExpandedByDefault]="false"
              >
              </app-sponsored-author-section>
              <app-advertorial-client
                [sponsoredClientControl]="
                  form.get(FORM_PATHS.SPONSORED_CLIENT())
                "
                [salesOrderControl]="
                  form.get(FORM_PATHS.SPONSORED_SALES_ORDER())
                "
                [isExpandedByDefault]="false"
                [isExpandable]="isEditMode"
              >
              </app-advertorial-client>
              <app-surtitles
                [surtitleControl]="form.get(FORM_PATHS.SURTITLES())"
                [tagControl]="form.get(FORM_PATHS.TAGS())"
                [typedTags]="form.get(FORM_PATHS.TYPED_TAGS())"
                [currentEditionLanguage]="
                  form.get(FORM_PATHS.EDITION_LANGUAGE())
                "
                [detailedTopicList]="
                  form.get(FORM_PATHS.TOPICS_WITH_TRANSLATIONS())
                "
                [isExpandedByDefault]="false"
                [isExpandable]="isEditMode"
                (handleAddToBody)="onAddToBody($event)"
                (handleRemoveLink)="onRemoveLink($event)"
              >
              </app-surtitles>
              <app-tagging
                [topicControl]="form.get(FORM_PATHS.TOPICS())"
                [tagControl]="form.get(FORM_PATHS.TAGS())"
                [companyControl]="form.get(FORM_PATHS.COMPANIES())"
                [peopleControl]="form.get(FORM_PATHS.PEOPLE())"
                [websites]="_buildDeliveryTargetCodes()"
                [isExpandedByDefault]="false"
                [isExpandable]="isEditMode"
                [isShowingPeopleAndCompanies]="false"
                [isShowingSurtitles]="true"
                (handleAddToBody)="onAddToBody($event)"
                (handleRemoveLink)="onRemoveLink($event)"
                (handleItemSelected)="onTagItemSelected($event)"
                (handleItemRemoved)="onTagItemRemoved($event)"
                (handleSurtitlePromoted)="onSurtitlePromoted($event)"
              ></app-tagging>
            </div>
            <div class="flex flex-col w-1/2 space-y-3 basis-1/2">
              <app-publish-time
                [publishTimeControl]="form.get(FORM_PATHS.PUBLISH_TIME())"
                [timezoneControl]="form.get(FORM_PATHS.TIMEZONE())"
                [showPublishTimeControl]="
                  form.get(FORM_PATHS.SHOW_PUBLISH_TIME())
                "
                [isExpandedByDefault]="false"
                [isExpandable]="isEditMode"
                [timezones]="timezones"
              ></app-publish-time>
              <app-authors
                id="formSectionAuthors"
                data-testid="formSectionAuthors"
                [isExpandedByDefault]="false"
                [isExpandable]="isEditMode"
                [selectedAuthors]="form.get(FORM_PATHS.SELECTED_AUTHORS())"
                [searchedAuthor]="searchedAuthor"
                [authorList]="authorList"
                [searchList]="searchList"
              ></app-authors>
              <app-expandable-dropdown
                id="formFieldBodyLanguage"
                [iconClass]="'icon-language'"
                [title]="'Language'"
                [sectionFormControl]="form.get(FORM_PATHS.LANGUAGE())"
                [labelKey]="'FriendlyName'"
                [options]="languages$ | async"
                [defaultOption]="DEFAULT_LANGUAGE_OPTION"
                [isExpandedByDefault]="false"
                [isExpandable]="isEditMode"
              ></app-expandable-dropdown>
              <app-visibility
                id="formSectionVisibility"
                data-testid="formSectionVisibility"
                [isExpandedByDefault]="false"
                [isExpandable]="isEditMode"
                [restrictToRegisteredUsersControl]="
                  form.get(FORM_PATHS.RESTRICTED_TO_REGISTERED_USERS())
                "
                [notForGoogleNewsSitemapsControl]="
                  form.get(FORM_PATHS.NOT_FOR_GOOGLE_NEWS_SITEMAPS())
                "
                [notForNewsFeedsControl]="
                  form.get(FORM_PATHS.NOT_FOR_NEWS_FEED())
                "
                [hideThisArticleControl]="
                  form.get(FORM_PATHS.HIDE_THIS_ARTICLE())
                "
                [paywallPremiumContent]="
                  form.get(FORM_PATHS.PAYWALL_PREMIUM_CONTENT())
                "
                [notForCompetitors]="form.get(FORM_PATHS.NOT_FOR_COMPETITORS())"
              ></app-visibility>
              <app-internal-information
                [urls]="initialSingleSponsorContent.dynamicData.liveUrls"
                [contentId]="initialSingleSponsorContent.contentId"
                [isExpandedByDefault]="false"
              ></app-internal-information>
              <app-version-list
                [versions]="initialSingleSponsorContent.dynamicData.versions"
                [articleId]="initialSingleSponsorContent.id"
                [latestPublishedVersionId]="
                  initialSingleSponsorContent.dynamicData
                    .latestPublishedVersionId
                "
                [latestVersionId]="
                  initialSingleSponsorContent.dynamicData.latestVersionId
                "
                [isExpandedByDefault]="false"
                [contentType]="CONTENT_TYPES.SINGLE_SPONSOR"
              ></app-version-list>

              <button
                mat-button
                type="button"
                class="h-8 text-xs font-semibold bg-project-4500/60 text-project-300"
                *ngIf="
                  !initialSingleSponsorContent.isPublished() &&
                  initialSingleSponsorContent.dynamicData.versions.length > 1
                "
                (click)="deleteUnpublishedDraft()"
                [disabled]="isProcessingStateChange || isSaving"
                mat-raised-button
                data-testid="deleteUnpublishedButton"
              >
                Delete Unpublished Draft
              </button>
              <button
                mat-button
                class="h-8 text-xs font-semibold bg-project-4500/60 text-project-300"
                *ngIf="!isNewSingleSponsor"
                (click)="deleteSingleSponsor()"
                [disabled]="isProcessingStateChange || isSaving"
                mat-raised-button
                data-testid="deleteButton"
              >
                Delete Single Sponsor
              </button>
              <button
                mat-button
                type="button"
                class="h-8 text-xs font-semibold bg-project-4500/60 text-project-300"
                *ngIf="
                  initialSingleSponsorContent.isPublished() &&
                  !initialSingleSponsorContent.isSpiked &&
                  initialSingleSponsorContent.dynamicData
                    .latestPublishedVersionId === initialSingleSponsorContent.id
                "
                (click)="spikeSingleSponsor()"
                mat-raised-button
                data-testid="spikeButton"
              >
                Spike
              </button>
            </div>
          </mat-accordion>
        </div>
      </form>
    </app-processing-boundary>
  </ng-container>
</div>
